import { Injectable } from '@angular/core';

/**
 * Service for providing helper functions related to number manipulation
 */
@Injectable({ providedIn: 'root' })
export class NumberHelperService {
    /**
     * Formats a number with a specified precision without losing precision.
     * @param {number} numberValue The number to be formatted.
     * @param {number} precision The number of decimal places to keep.
     * @returns {string} The formatted number as a string with the specified precision.
     */
    toFixedWithPrecision(numberValue: number, precision: number): string {
        const multiplier = Math.pow(10, precision);
        const rounded = Math.round(numberValue * multiplier);
        return (rounded / multiplier).toFixed(precision);
    }

    isValidNumber(num: any): boolean {
        return typeof num === 'number' && !isNaN(num) && isFinite(num);
    }
}
